import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DisclosureGate } from "@/components/DisclosureGate";

export function ProtectedRoute({ children, pro = false }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-600" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (!pro && user.role === "pro") return <Navigate to="/pro" replace />;
  if (pro && user.role !== "pro") return <Navigate to="/dashboard" replace />;
  if (user.role === "user" && user.needs_disclosure) return <DisclosureGate />;
  return children;
}
